import {injectable} from "inversify";
import Scene = Phaser.Scene;
import ListenerManager from "@/managers/listener-manager";
import CU from "@/utils/c-u";

@injectable()
export class MailOrPhoneService {

    public async open(scene: Scene, canvas: HTMLCanvasElement) {
        this.openSetEmailOrPhonePage(scene);
    }

    private openSetEmailOrPhonePage(scene: Scene) {
        CU.blockCanvas(scene!);
        ListenerManager.callChangeEmailOrPhoneCallback();
    }
}